import { FC } from "react";
import { IconPropsType } from ".";

export const TinyAngleLeft: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="4"
      height="6"
      viewBox="0 0 4 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 0.5L1 3L3.5 5.5"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
